export const DATA_PRIVACY_LINK = 'https://www.atlassian.com/legal/privacy-policy';
export const PREMIUM_UPSELL_BANNER = 'PremiumUpsellBanner';
